<template>
	<div class="midlle">
		<div class="myProject">

			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">已创建的部门</div>
				</div>
				<el-table :data="DepartmentList" stripe style="width: 100%" border="">
					<el-table-column prop="id" label="部门号" width="114" :resizable="false">
					</el-table-column>
					<el-table-column prop="name" label="部门名称" width="196" :resizable="false">

					</el-table-column>
					<el-table-column label="当前状态" width="154" :resizable="false">
						<template slot-scope="scope">
							<!-- 1=正常,2=暂停,3=注销 -->
							<p v-if="scope.row.status == 0">
								<span>停运</span> <span style="margin:6px">|</span>
								<span style="cursor: pointer;" @click.stop="changeStatus(scope.row)">更改</span>
							</p>
							<p v-if="scope.row.status == 1">
								<span>正常</span> <span style="margin:6px;">|</span>
								<span style="cursor: pointer;" @click.stop="changeStatus(scope.row)">更改</span>
							</p>
						
						</template>
					</el-table-column>
					<el-table-column label="管理员" width="164" :resizable="false">
						<template slot-scope="scope">
							<p>
								<span>{{scope.row.user_name}}</span>
								<span style="margin:6px;">|</span>
								<span style="cursor: pointer;" @click.stop="changeAdmin(scope.row)">更改</span>
							</p>
						</template>
					</el-table-column>
					
					<el-table-column label="备注" width="210" :resizable="false">
						<template slot-scope="scope">
							<p style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
								{{scope.row.remark}}
							</p>
						</template>
					</el-table-column>



				</el-table>
				<div class="addCompany" @click="addNew = true">
					+新建部门
				</div>
				<el-dialog :lock-scroll='false' title="修改部门状态" :visible.sync="statusDialogVisible" width="30%" center>
					<div style="display: flex;justify-content: center;padding: 25px;">
						<el-select v-model="statusValue" placeholder="请选择">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="statusDialogVisible = false">取 消</el-button>
						<el-button style="background: #0052d9;" type="primary" @click="statusConfirm">确 定</el-button>
					</span>
				</el-dialog>
				<el-dialog :lock-scroll='false' title="更换管理员" :visible.sync="adminDialogVisible" width="400px" center>
					<div style="display: flex;justify-content: center;padding: 25px;">
						<el-select v-model="adminValue" placeholder="请选择">
							<el-option v-for="item in adminOptions" :key="item.id" :label="item.nickname"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="adminDialogVisible = false">取 消</el-button>
						<el-button style="background: #0052d9;" type="primary" @click="adminConfirm">确 定</el-button>
					</span>
				</el-dialog>
				<el-dialog :lock-scroll='false' title="新增部门" :visible.sync="addNew" width="700px" center>
					<div style="display: flex;justify-content: center;padding: 25px;flex-wrap: wrap;">

						<div class="form-item">
							<div class="form-item-title">
								<div>部门名称</div>
								<span>:</span>
							</div>
							<div class="inp">
								<input type="text" v-model="addNewDepart.name"  placeholder="请输入部门名称">
							</div>
						</div>
						<div class="form-item">
							<div class="form-item-title">
								<div>管理员</div>
								<span>:</span>
							</div>
							<div class="inp">
								<el-select v-model="addNewDepart.user_id" placeholder="请选择">
									<el-option v-for="item in adminOptions" :key="item.id" :label="item.nickname"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="form-item">
							<div class="form-item-title">
								<div>备注信息</div>
								<span>:</span>
							</div>
							<div class="inp">
								<input type="text" v-model="addNewDepart.remark"  placeholder="请输入备注信息">
							</div>
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="addNew = false">取 消</el-button>
						<el-button style="background: #0052d9;" type="primary" @click="addDepartment">确 定</el-button>
					</span>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import isEmpty from '../../utils/isEmpty.js'
	export default {
		data() {
			return {
				addNew:false,
				statusDialogVisible: false,
				adminDialogVisible: false,
				tableData3: [],
				statusOptions: [{
					value: 0,
					label: '停运'
				}, {
					value: 1,
					label: '正常'
				},
				],
				statusValue: '',
				statusID: '',
				adminOptions: [],
				adminValue: '',
				adminID: '',
				form:{
					name:'',
					admin:'',
					BZ:''
				},
				addNewDepart:{
					company_id:'',
					name:'',
					remark:'',
					user_id:''
				},
				DepartmentList:[]
			}
		},
		created() {
			this.getDepartmentList()
			this.getRelevance()
		},
		methods: {
			// departmentChangeStatus
			async addDepartment(){
				if(this.addNewDepart.name == ''){
					this.$message({
						message:'请输入部门名称',
						type:'error'
					})
					return
				}
				this.addNewDepart.company_id = this.$store.state.companyInfo.id
				const add = await this.$api.addDepartment({...this.addNewDepart})
				if(add.code == 1){
					this.$message({
						message:add.msg,
						type:'success'
					})
					this.addNew = false
					this.getDepartmentList()
				}else{
					this.$message({
						message:add.msg,
						type:'warning'
					})
				}
			},
			async changeAdmin(){
			},
			async getRelevance(){
				const list = await this.$api.getRelevanceWithCompany({company_id:this.$store.state.companyInfo.id})
				this.adminOptions = list.data
			},
			async getDepartmentList(){
				const list = await this.$api.getDepartmentList({company_id:this.$store.state.companyInfo.id})
				this.DepartmentList = list.data
			},
			changeStatus(row) {
				this.statusDialogVisible = true
				this.statusID = row.id
				// this.statusValue = row.status
			},
			async statusConfirm() {
				const change = await this.$api.departmentChangeStatus({id:this.statusID,status:this.statusValue})
				if(change.code == 1){
					this.$message({
						message:change.msg,
						type:'success'
					})
					this.statusDialogVisible = false
					this.statusValue = ''
					this.getDepartmentList()
				}else{
					this.$message({
						message:change.msg,
						type:'warning'
					})
				}
			},
			changeAdmin(row) {
				this.adminDialogVisible = true
				this.adminID = row.id
				this.adminValue = row.nickname
			},
			async adminConfirm() {
				const change = await this.$api.departmentChangeAdmin({id:this.adminID,user_id:this.adminValue})
				if(change.code == 1){
					this.$message({
						message:change.msg,
						type:'success'
					})
					this.adminDialogVisible = false
					this.adminValue = ''
					this.getDepartmentList()
				}else{
					this.$message({
						message:change.msg,
						type:'warning'
					})
				}
			},

		}
	}
</script>

<style lang="less" scoped>
	.form-item {
		display: flex;
		margin-bottom: 30px;
		align-items: baseline;
		/deep/.el-input__inner::placeholder{
			color: #999999;
		}
		/deep/.el-input__inner{
			width: 448px;
		}
		.inp {
			margin-left: 40px;
	
			& input {
				font-size: 18px;
				padding: 0 15px;
				box-sizing: border-box;
				width: 448px;
				height: 45px;
				border: 1px solid #D2D2D2;
				border-radius: 6px;
			}
		}
	
		.form-item-title {
			font-size: 18px;
			display: flex;
			align-items: center;
	
			&>div {
				width: 77px;
				text-align-last: justify;
			}
		}
	}
	/deep/.el-input__inner {

		border: 1px solid #D2D2D2;
		line-height: 45px;
		font-size: 18px;
		color: black !important;
		height: 45px;
		box-sizing: border-box;
	}

	.midlle-body {
		.addCompany {
			width: 261px;
			height: 40px;
			background: #0052D9;
			cursor: pointer;
			margin: auto;
			margin-top: 30px;
			color: white;
			line-height: 40px;
			text-align: center;
		}

		padding-bottom: 10px;

		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}

		padding-top: 20px;
		box-sizing: border-box;
		background: white;

		.body-title {
			color: #0052D9;
			display: flex;
			margin-bottom: 20px;
			font-weight: bold;
			font-size: 18px;

			.line {
				width: 4px;
				height: 22px;
				background: #0052D9;
			}
		}

		.loading {
			cursor: pointer;
			width: 116px;
			height: 40px;
			background: #F6F6F6;
			display: flex;
			align-items: center;
			margin: 10px;
			margin-bottom: 0;
			justify-content: center;
		}

	}

	.midlle {
		.myProject {
			width: 840px;
			padding: 20px 0;
			padding-top: 0;
			background: #FFFFFF;
		}

		width: 880px;
		padding: 0 20px;
		box-sizing: border-box;

		.title {
			display: flex;
			height: 40px;
			background: #E5EDFB;
			align-items: center;

			p {
				font-size: 14px;
				color: black;
				margin-left: 10px;

				span {
					color: #0052D9;
				}
			}

			.tit {
				display: inline-block;
				padding: 0 20px;
				background: #0052D9;
				height: 40px;
				line-height: 40px;
				color: white;
				font-size: 18px;
				border-radius: 0px 20px 20px 0px;
				font-weight: bold;
			}
		}
	}
</style>